<template>
    <div class="shop-area shop-area--theme mb-20">
        <div class="container">
            <div class="row">
                <!-- shop sidebar area start -->
                <shop-sidebar-area></shop-sidebar-area>
                <!-- shop sidebar area end -->
                <div class="col-xl-9 col-lg-8">
                    <div class="shop-banner mb-30">
                        <div class="banner-image">
                            <img class="banner-l" :src="bannerMain" alt="">
                            <img class="banner-sm" :src="bannerSmall" alt="">
                            <div class="banner-content text-center">
                                <p class="banner-text mb-30" v-html="bannerText"></p>
                                <router-link :to="bannerButtonLink" class="st-btn-d b-radius">
                                    {{ bannerButtonText }}
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="product-lists-top">
                        <div class="product__filter-wrap">
                            <div class="row align-items-center">
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                                    <div class="product__filter d-sm-flex align-items-center">
                                        <div class="product__col">
                                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link"
                                                        :class="{ active: activeTab === 'FourCol' }" id="FourCol-tab"
                                                        data-bs-toggle="tab" data-bs-target="#FourCol" type="button"
                                                        role="tab" @click="activeTab = 'FourCol'"
                                                        aria-controls="FourCol"
                                                        :aria-selected="activeTab === 'FourCol' ? 'true' : 'false'">
                                                        <i class="fas fa-th"></i>
                                                    </button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link"
                                                        :class="{ active: activeTab === 'FiveCol' }" id="FiveCol-tab"
                                                        data-bs-toggle="tab" data-bs-target="#FiveCol" type="button"
                                                        tabindex="-1" @click="activeTab = 'FiveCol'" role="tab"
                                                        aria-controls="FiveCol"
                                                        :aria-selected="activeTab === 'FiveCol' ? 'true' : 'false'">
                                                        <i class="fas fa-list"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="product__result pl-60">
                                            <p> Showing 1–{{ product_data.slice(startIndex, endIndex).length }} of {{
                                                product_data.length }} results</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                                    <div class="product__filter-right d-flex align-items-center justify-content-md-end">
                                        <div class="product__sorting product__show-position ml-20">
                                            <ui-nice-select :options="sortOptions"
                                                :model-value="sortModelValue"
                                                name="Select Shorting"
                                                :default-current="0"
                                                placeholder="Sort products"
                                                @onChange="store.handleSelectFilter" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="product_data.length === 0" class="cartmini__empty text-center mt-80 mb-80">
                        <img src="@/assets/images/product/empty-cart.png" alt="empty-cart-img" />
                        <h4>Sorry! Couldn't find the product you were looking For!!!</h4>
                        <p>Please check if you have misspelt something or try searching with other words.</p>
                        <router-link to="/shop" class="cart-btn">Continue Shopping</router-link>
                    </div>

                    <div v-else>

                        <div class="tab-content" id="productGridTabContent">
                            <div class="tab-pane fade" :class="{ 'show active': activeTab === 'FourCol' }" id="FourCol"
                                role="tabpanel" aria-labelledby="FourCol-tab">
                                <div class="tp-wrapper">
                                    <div class="row g-0">
                                        <div v-for="item in filteredProductsItems.slice(startIndex, endIndex)"
                                            :key="item.id" class="col-lg-3 col-md-4 col-sm-6">
                                            <product-single :product="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" :class="{ 'show active': activeTab === 'FiveCol' }" id="FiveCol"
                                role="tabpanel" aria-labelledby="FiveCol-tab">
                                <div class="tp-wrapper-2">
                                    <product-list-item v-for="item in filteredProductsItems.slice(startIndex, endIndex)"
                                        :key="item.id" :product="item" />
                                </div>
                            </div>
                        </div>

                        <div class="tp-pagination text-center">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="basic-pagination pt-30 pb-30">
                                        <ui-pagination :items-per-page="limit" :data="totalProducts"
                                            @handle-paginate="handlePagination" />
                                    </div>
                                </div>
                            </div>
                        </div>

                       <!--  <div class="tp-pagination text-center">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="basic-pagination pt-30 pb-30">
                                        <ui-pagination :items-per-page="8" :data="filteredProductsItems"
                                            @handle-paginate="handlePagination" />
                                    </div>
                                </div>
                            </div>
                        </div> -->



                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import slbanner from '@/assets/images/banner/sl-banner.jpg'
import slbannersm from '@/assets/images/banner/sl-banner-sm.png'
import ShopSidebarArea from '@/components/shop/sidebar/shop-sidebar-area.vue'
import ProductSingle from '@/components/product/product-single-3.vue'
import UiPagination from '@/components/ui/pagination.vue'
import ProductListItem from '@/components/product/product-list-item.vue'
// eslint-disable-next-line no-unused-vars
//import product_data from "@/data/product-data";
import { useProductFilterStore } from "@/stores/useProductFilterStore"

export default {
    name: "HeaderOne",
    components: {
        ShopSidebarArea,
        ProductSingle,
        ProductListItem,
        UiPagination
    },
    data() {
        const store = useProductFilterStore()
        return {
            slbanner,
            slbannersm,
            store,
            // Shop banner CMS data (id=3 in page_contents table)
            shopBanner: {},
            cate_menu: false,
            isSidebarOpen: false,
            category_data: [],
            product_data: [],
            searchText: '',
            category_value: '',
            category_options: [],
            filteredProductsItems: [],
            offset: 0, // Current offset
            limit: 12, // Items per page
            totalProducts: 0, // Total products count from backend
            startIndex : 0,
            endIndex : 12,
            activeTab: 'FourCol'
        }
    },
    computed: {
        bannerMain() {
            return this.shopBanner.shop_banner_main_image_url || this.slbanner
        },
        bannerSmall() {
            return this.shopBanner.shop_banner_small_image_url || this.slbannersm
        },
        bannerText() {
            const raw = this.shopBanner.shop_banner_text
            if (!raw) return 'Hurry Up! <br> Free Shipping All Order Over $99'
            // preserve any explicit line breaks entered by the admin
            return raw.replace(/\n/g, '<br>')
        },
        bannerButtonText() {
            return this.shopBanner.shop_banner_button_text || 'Discover now'
        },
        bannerButtonLink() {
            return this.shopBanner.shop_banner_button_link || '/shop'
        },
        sortOptions() {
            return [
                { value: 'default', text: 'Default Sorting' },
                { value: 'high', text: 'Low to High' },
                { value: 'low', text: 'High to Low' },
                { value: 'new', text: 'New Added' },
                { value: 'sale', text: 'On Sale' },
            ]
        },
        sortModelValue() {
            const sv = this.store.selectVal
            if (typeof sv === 'string' && sv) return sv
            if (sv && sv.value != null) return String(sv.value)
            return 'default'
        },
    },
    methods: {
        async fetchShopBanner() {
            try {
                const { data } = await this.$axios.get('/cms/shop')
                this.shopBanner = data || {}
            } catch (err) {
                console.error('Error loading shop banner:', err)
            }
        },
        /** Single string from route query (handles ?key= repeated as array). */
        queryString(param) {
            const v = this.$route.query[param]
            if (v == null || v === '') return ''
            return Array.isArray(v) ? String(v[0] ?? '').trim() : String(v).trim()
        },
        async fetchProducts() {
            try {
                // Extract query parameters from the route (searchText comes from header search → /shop)
                const category = this.queryString('category')
                const sub_cat =
                  this.queryString('category_child') ||
                  this.queryString('sub_category')
                const web_category = this.queryString('web_category')
                const brand = this.queryString('brand')
                const size = this.queryString('size')
                const minPrice = this.queryString('minPrice')
                const maxPrice = this.queryString('maxPrice')
                const searchText = this.queryString('searchText')

                let sortKey = ''
                const sv = this.store.selectVal
                if (typeof sv === 'string') sortKey = sv
                else if (sv && sv.value != null)
                  sortKey = String(sv.value)

                // Build query string dynamically
                const queryParams = new URLSearchParams()
                if (web_category) queryParams.append("web_category", web_category)
                if (category) queryParams.append("category", category)
                if (sub_cat) queryParams.append("category_child", sub_cat)
                if (brand) queryParams.append("brand", brand)
                if (size) queryParams.append("size", size)
                if (minPrice) queryParams.append("minPrice", minPrice)
                if (maxPrice) queryParams.append("maxPrice", maxPrice)
                if (searchText) queryParams.append("searchText", searchText)
                const normalizedSort =
                  sortKey &&
                  ['high', 'low', 'new', 'sale', 'default'].includes(sortKey)
                    ? sortKey
                    : ''
                if (
                  normalizedSort &&
                  normalizedSort !== '' &&
                  normalizedSort !== 'default'
                ) {
                  queryParams.append('sort', normalizedSort)
                }

                // Include offset and limit for pagination
                queryParams.append("offset", this.offset)
                queryParams.append("limit", this.limit)

                // Make Axios GET request with query parameters
                // const response = await this.$axios.get(`/available-products?${queryParams.toString()}`)
                const response = await this.$axios.get(`/shop-products?${queryParams.toString()}`)

                console.log('Shop products response:', response.data)

                // Update product data and reset pagination
                this.product_data = response.data.data
                this.filteredProductsItems = response.data.data
                this.totalProducts = response.data.total // Total count of products from backend

                // Reset pagination indices
                this.startIndex = 0
                this.endIndex = 12

            } catch (error) {
                console.error("Error fetching products:", error)
                console.error("Error response:", error.response)
                // Set empty arrays on error
                this.product_data = []
                this.filteredProductsItems = []
                this.totalProducts = 0
            }
        },


        async fetchCategories() {
           try {
                const response = await this.$axios.get('/web-categories')
                // Handle different response structures
                const categories = response.data?.rows || response.data?.data || response.data || []
                this.category_data = Array.isArray(categories) ? categories : []
                console.log('Categories response:', response.data)
                
                if (this.category_data && this.category_data.length > 0) {
                    this.category_options = this.category_data.map(item => ({
                        value: item.cat_id || item.id,
                        text: item.cat_name || item.name,
                    }))
                    this.category_options.unshift({ value: "all", text: "All Category" })
                } else {
                    this.category_options = [{ value: "all", text: "All Category" }]
                }
            } catch (error) {
                console.error("Error fetching categories:", error)
                // Set default category option on error
                this.category_options = [{ value: "all", text: "All Category" }]
                this.category_data = []
            }
        },
        renderCategoryName(name) {
            return name.replace('&', '<br/> &')
        },
        isLastItem(index) {
            return index === this.category_data.length - 1
        },
        formatUrl(slug) {
            return slug.replace(/\s+/g, '-').toLowerCase()
        },
        handlePagination(data, start) {
            // Calculate offset from the start index
            this.offset = start
            this.fetchProducts() // Fetch new data for the current page
        }
    },
    mounted() {
        this.fetchShopBanner()
        this.fetchProducts()
        this.fetchCategories()
        // Watch for changes in route query parameters
        /* fullPath: re-run fetch when navigating to Shop with identical query objects
           (Vue Router may not mutate query ref, deep watch alone sometimes misses repeats). */
        this.$watch(
            () => this.$route.fullPath,
            () => {
                if (this.$route.name !== 'Shop') return
                this.offset = 0
                this.fetchProducts()
            }
        )

        this.$watch(
            () => this.store.selectVal,
            () => {
                if (this.$route.name !== 'Shop') return
                this.offset = 0
                this.fetchProducts()
            },
            { deep: true }
        )

    }
}
</script>

<style scoped>
/* Add styles for Home page */
.banner-image .banner-sm {
    position: absolute;
    right: 22%;
    top: 50%;
    transform: translateY(-50%);
}

/* Product grid / list + empty state — white labels, themed fill, rounded pill buttons */
.shop-area--theme :deep(.cart-btn) {
    color: #ffffff !important;
    background: linear-gradient(
        180deg,
        var(--fe-accent, #fcbe00) 0%,
        color-mix(in srgb, var(--fe-accent-hover, #e5ac00) 92%, #1a1a1a 8%) 100%
    ) !important;
    border: 1px solid transparent !important;
    border-radius: 999px !important;
    box-shadow:
        0 4px 14px color-mix(in srgb, var(--fe-accent, #fcbe00) 35%, transparent) !important;
}

.shop-area--theme :deep(.cart-btn:hover) {
    color: #ffffff !important;
    filter: brightness(1.06);
}

.shop-area--theme :deep(.st-btn-d) {
    color: #ffffff !important;
}
</style>